import React, { useEffect, useState } from 'react';
import axios from 'axios';

const REQUESTS_API = 'https://oppiesfunc.azurewebsites.net/api/getShopChangeRequests?code=YyFeMRwgihAfH8G4wsB5rRis7LwH8yFBy5a4mj0LIi1hAzFugeyiiQ==';
const APPROVE_API = 'https://oppiesfunc.azurewebsites.net/api/approveShopChangeRequest?code=t7FCJR8iLR0_MVQwTRRF4sVvwZO6s_hXNIJOzxhD9aZfAzFuhY2SHw==';
const REJECT_API = 'https://oppiesfunc.azurewebsites.net/api/rejectShopChangeRequest?code=Z4Y83xPIDPBVpWk0XwReSrlBE5KG5t-0ur3LIBbi9N7IAzFutg0vjw==';

function ChangeRequestManager() {
    const [requests, setRequests] = useState([]);
    const [status, setStatus] = useState('');

    useEffect(() => {
        fetchRequests();
    }, []);

    const fetchRequests = async () => {
        try {
            const res = await axios.get(REQUESTS_API);
            setRequests(res.data);
        } catch (err) {
            console.error('Failed to load change requests:', err);
            setStatus('Failed to load requests.');
        }
    };

    const handleApprove = async (request) => {
        try {
            await axios.post(APPROVE_API, { ...request });
            setRequests((prev) => prev.filter((r) => r.id !== request.id));
            setStatus(`Approved changes for ${request.shopId}`);
        } catch (err) {
            console.error('Approval error:', err);
            setStatus('Error approving request.');
        }
    };

    const handleReject = async (request) => {
        try {
            await axios.post(REJECT_API, { id: request.id });
            setRequests((prev) => prev.filter((r) => r.id !== request.id));
            setStatus(`Rejected changes for ${request.shopId}`);
        } catch (err) {
            console.error('Rejection error:', err);
            setStatus('Error rejecting request.');
        }
    };

    return (
        <div style={styles.container}>
            <h2>Pending Shop Change Requests</h2>
            {status && <p style={status.includes('❌') ? styles.error : styles.success}>{status}</p>}

            {requests.length === 0 ? (
                <p>No pending change requests.</p>
            ) : (
                requests.map((r) => (
                    <div key={r.id} style={styles.card}>
                        <p><strong>Shop ID:</strong> {r.shopId}</p>
                        <p><strong>New Name:</strong> {r.name}</p>
                        <p><strong>New Email:</strong> {r.email}</p>
                        <p><strong>New Address:</strong> {r.address}</p>
                        <p><strong>New Contact:</strong> {r.contact}</p>
                        <div style={styles.btnRow}>
                            <button style={styles.approveBtn} onClick={() => handleApprove(r)}>Approve</button>
                            <button style={styles.rejectBtn} onClick={() => handleReject(r)}>Reject</button>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
}

const styles = {
    container: { padding: 30, maxWidth: 700, margin: '0 auto' },
    card: {
        border: '1px solid #ccc',
        padding: 15,
        marginBottom: 15,
        borderRadius: 8,
        background: '#f9f9f9',
    },
    btnRow: { display: 'flex', gap: 10, marginTop: 10 },
    approveBtn: {
        background: '#4CAF50',
        color: 'white',
        padding: '8px 12px',
        border: 'none',
        borderRadius: 5,
        cursor: 'pointer',
    },
    rejectBtn: {
        background: '#cc0000',
        color: 'white',
        padding: '8px 12px',
        border: 'none',
        borderRadius: 5,
        cursor: 'pointer',
    },
    success: { color: 'green', marginBottom: 10 },
    error: { color: 'red', marginBottom: 10 },
};

export default ChangeRequestManager;// JavaScript source code
